import raf from "raf";

/**
 * @module
 *
 */

const selector = "[data-js-content-block]";
const contentBlock = function (el, app) {
    const $el = $(el);
    const $items = $el.find(".Ge-ContentBlock-2025-Chapters-Item");
    const $anchors = $el.find(".Ge-ContentBlock-2025-ChapterHeader-Anchor");

    const visible = new Set();

    const init = function () {
        registerEvents();
    };

    const registerEvents = function () {
        const options = {
            root: null,
            rootMargin: "0px",
            threshold: [0, 1],
        };

        const observer = new IntersectionObserver(function (entries) {
            for (const c of entries) {
                if (c.intersectionRatio > 0.9) {
                    // console.log('visible: ' + c.target.id);
                    visible.add(c.target.id);
                } else {
                    // console.log('not visible: ' + c.target.id);
                    visible.delete(c.target.id);
                }
            }

            for (let i = 0; i < $items.length; i++) {
                const $item = $items.eq(i);
                const anchorId = $item.attr("data-js-anchor-id");
                // console.log( 'look for: ' + anchorId);

                // Set first visible anchor as selected
                if (visible.has(anchorId)) {
                    // console.log( 'found');
                    $items.removeClass(
                        "Ge-ContentBlock-2025-Chapters-Item--selected",
                    );
                    $item.addClass(
                        "Ge-ContentBlock-2025-Chapters-Item--selected",
                    );
                    return;
                }
            }

            // If there are no visible anchors, don't change selection
        }, options);

        for (let e = 0; e < $anchors.length; e++) {
            observer.observe($anchors[e]);
        }
    };

    return {
        init: init(),
    };
};

contentBlock.selector = selector;

export default contentBlock;
